import { render } from "./ChatFaq.vue?vue&type=template&id=74e669d6&scoped=true"
import script from "./ChatFaq.vue?vue&type=script&lang=js"
export * from "./ChatFaq.vue?vue&type=script&lang=js"

import "./ChatFaq.vue?vue&type=style&index=0&id=74e669d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e669d6"]])

export default __exports__